import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    getApplicantActions,
    getApplicantActionById,
    createApplicantAction
} from "api/menu/hr/applicant-actions/requests";

export const APPLICANT_ACTIONS_REQUEST_LOADING = "APPLICANT_ACTIONS_REQUEST_LOADING";
export const APPLICANT_ACTIONS_REQUEST_ERRORS = "APPLICANT_ACTIONS_REQUEST_ERRORS";
export const FETCH_APPLICANT_ACTIONS_SUCCESS = "FETCH_APPLICANT_ACTIONS_SUCCESS";
export const FETCH_APPLICANT_ACTION_BY_ID_SUCCESS = "FETCH_APPLICANT_ACTION_BY_ID_SUCCESS";

export const setLoading = () => ({ type: APPLICANT_ACTIONS_REQUEST_LOADING });

export const fetchApplicantActions = (applicantId) => dispatch => {
    dispatch(setLoading());
    getApplicantActions(applicantId)
        .then(response => {
            dispatch({ type: FETCH_APPLICANT_ACTIONS_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, APPLICANT_ACTIONS_REQUEST_ERRORS));
        });
};

export const fetchApplicantActionById = (id) => dispatch => {
    getApplicantActionById(id)
        .then(response => {
            dispatch({ type: FETCH_APPLICANT_ACTION_BY_ID_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, APPLICANT_ACTIONS_REQUEST_ERRORS));
        });
};

export const createApplicantActionRequest = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    createApplicantAction(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            const actionTypeText = data.action === "Contact" ? "Contact" : "Comment";
            toast(`${actionTypeText} action recorded successfully`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(true);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const clearApplicantActions = () => dispatch => {
    dispatch({ type: FETCH_APPLICANT_ACTIONS_SUCCESS, payload: [] });
};
